import { css } from 'lit'

export default css`
    :host {
        display: block;
        outline: none;
    }

    .box {
        border: 1px solid var(--SelectBox-border-color, var(--grey4, black));
        border-right: var(--SelectBox-border-right, 1px solid var(--SelectBox-border-color, var(--grey4, black)));
        display: flex;
        align-items: center;
        padding: var(--SelectBox-padding, 4px 12px);
        cursor: pointer;
        border-radius: var(--SelectBox-border-radius, 5px);
        background: white;
        color: var(--grey1);
        height: var(--SelectBox-height, auto);
    }

    :host(:focus) .box {
        border-color: var(--primary-color) !important;
    }

    :host(:hover) .box {
        border-color: var(--grey3);
    }

    .box.invalid {
        border-color: #e44967;
    }

    .box.disabled,
    .box.readonly {
        background: var(--disabled);
        cursor: auto;
        color: #9cabb9;
    }
`
